export default __webpack_public_path__ + "static/media/facebook-white.e6fc201c.svg";